import { NgModule } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { AgrSharedModule } from '@next/core-lib/shared';

import { InformationCardComponent } from './components/information-card/information-card.component';

@NgModule({
  declarations: [InformationCardComponent],
  imports: [AgrSharedModule, MatCardModule],
  exports: [AgrSharedModule, InformationCardComponent],
})
export class SharedModule {}
